import Cookies from 'js-cookie';

let alertsClosed = [];
let alertsCookie = function() {
  var alertsCookie = Cookies.get('alerts_closed');
  if(alertsCookie) {  alertsClosed = JSON.parse(alertsCookie); }
};

function remove_alert(element) {
  $(element).remove();
  window.dispatchEvent(new Event('resize'));
}

function save_to_cookie(alertID) {
  // Add to array
  alertsClosed.push(alertID);

  // Save to cookie
  Cookies.set('alerts_closed', JSON.stringify(alertsClosed), { expires: 7 });
}

export function check_alerts() {
  alertsCookie();
  alertsClosed.forEach(alertID => remove_alert($('.alert[data-alert-id="'+alertID+'"]')));
  $('.alert').removeClass('d-none');
}

export function close_alert() {

  $('.alert-site-wide .alert-close').on('click touch', function(e) {
    e.preventDefault();
    var alert = $(this).parent(),
        alertID = alert.data('alert-id');

      remove_alert(alert);
      save_to_cookie(alertID);
  });

}



// WEBPACK FOOTER //
// ./scripts/functions/alerts.js